import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-draw-processing-time-modal',
  imports: [BaseModalComponent, TranslocoDirective],
  templateUrl: './draw-processing-time-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawProcessingTimeModalComponent {
  confirm = output<void>();

  cancel = output<void>();

  protected onConfirm(): void {
    this.confirm.emit();
  }

  protected onCancel(): void {
    this.cancel.emit();
  }
}
